import React, { useState } from "react";
import { DelayInput } from "react-delay-input/lib/Component";
import DefaultButton from "../../styles/materialButtonStyle";
import Dropdown from "rc-dropdown";
import ProjectsSelect from "../../elements/projects/ProjectsSelect";
import { useTranslation } from "react-i18next";

import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledSelectGroup,
  StyledShowFilterBtn
} from "../../elements/filter/styledFiter";
import ServicesSelect from "./ServicesSelect";

const RatesFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("ratesPage");
  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    let clearFilterData = {
      "page": 1,
      "rateBase.currency.asset": "",
      "itemsPerPage": filterData["itemsPerPage"] ?? null
    };
    setFilterData(clearFilterData);
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton
                color="transparent"
                onClick={handleClearFilter}
              >
                {t("rates.filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
            <StyledFilterGroup className="close-btn">
              <StyledFilterCloseBtn onClick={() => setVisible(false)} />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("rates.filter.filterBy")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="1">
            <StyledFilterGroup>
              <label htmlFor="asset">
                {t("rates.filter.asset")}
              </label>
              <DelayInput
                id="asset"
                delayTimeout={2000}
                onChange={event => setFilterData({
                  ...filterData,
                  "rateBase.currency.asset": event.target.value,
                  page: 1
                })}
                name="asset"
                value={filterData["rateBase.currency.asset"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledSelectGroup>
              <ServicesSelect
                checkedService={filterData["connection.service.name"]}
                setCheckedService={(data) => setFilterData({ ...filterData, "connection.service.name": data, page: 1 })}
                isObject={false}
                defaultOption={true}
              />
            </StyledSelectGroup>
            <StyledSelectGroup>
              <ProjectsSelect
                checkedProjects={filterData["connection.project.name"]}
                setCheckedProjects={(data) => setFilterData({
                  ...filterData,
                  "connection.project.name": data,
                  page: 1
                })}
                isObject={false}
                defaultOption={true}
              />
            </StyledSelectGroup>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("rates.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default RatesFilter;